import { Colors, Flex, IconRefresh, Typography } from '@banhala/ui-kit';
import { useNavigation, useRoute } from '@react-navigation/native';
import { useFilterListAtom } from '../Provider/filterList/useFilterListAtom';
import { useFilterListBottomSheetAtom } from '../Provider/filterListBottomSheet/useFilterListBottomSheetAtom';
import type { AnyObject } from '../../../../../types';
import { useLogClickFilter } from '../hooks/useLogClickFilter';

type ResetChipProps = {
  closeSearchBar: VoidFunction;
  logging: AnyObject;
  radioQueryName?: string;
};

export const ResetChip = ({
  closeSearchBar,
  logging,
  radioQueryName,
}: ResetChipProps) => {
  const { clearChipFilters } = useFilterListAtom();
  const { clearFilterListBottomSheet } = useFilterListBottomSheetAtom();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation = useNavigation<any>();
  const { params } = useRoute();
  const logClickFilter = useLogClickFilter(logging);

  const handleResetButton = () => {
    logClickFilter({ selectedItem: '초기화' });
    closeSearchBar();
    clearFilterListBottomSheet();

    // 칩 필터만 초기화 (라디오 필터는 보존)
    clearChipFilters(radioQueryName);

    // next_token, screen_name, 라디오 필터를 제외한 모든 params를 undefined로 설정하여 제거
    const paramsToReset = Object.keys(params ?? {}).reduce(
      (acc, key) => {
        if (
          key === 'next_token' ||
          key === 'screen_name' ||
          key === 'instanceId' ||
          key === radioQueryName
        ) {
          return acc;
        }
        acc[key] = undefined;
        return acc;
      },
      {} as Record<string, undefined>,
    );

    navigation.setParams(paramsToReset);
  };

  return (
    <Flex.Row
      gap={4}
      alignItems="center"
      borderWidth={1}
      padding={{ horizontal: 12, vertical: 9 }}
      borderRadius={18}
      borderColor="border_slate_secondary"
      onPress={handleResetButton}
    >
      <Typography type="subtitle3" color="content_secondary">
        초기화
      </Typography>
      <IconRefresh
        width={16}
        height={16}
        fill={Colors.content_secondary}
      />
    </Flex.Row>
  );
};
